import WaitingRoom from "../components/WaitingRoom/WaitingRoom";

export default function WaitingPage() {
    return <WaitingRoom />;
}
